var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.count > 0),expression:"count > 0"}],staticClass:"red badge new"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }